module.exports = __webpack_public_path__ + "static/media/premio.4d361e6f.svg";